export const FILE_EXTENSION_CSV = 'csv';
export const FILE_EXTENSION_XLS = 'xls';
export const EXPORT_FILE = 'exports';
